module.exports = __webpack_public_path__ + "static/media/company-background.5cff7712.png";